@if (model$ | async; as model) {
    <section
        class="product-list-results"
        tabindex="-1"
        [attr.aria-label]="'productList.productListResults' | cxTranslate">
        @if (viewMode$ | async; as viewMode) {
            <div class="cx-sorting top">
                <div #fixedFacets class="cx-sorting-fixed noPrint" [ngClass]="isOpen ? 'top' : ''">
                    <div class="cx-sorting-inner">
                        <div class="cx-sorting-padding">
                            <!-- Mobile facets sticky -->
                            <div class="d-block d-md-none">
                                <div class="row">
                                    <div class="col-4 facet-list">
                                        <aimo-product-facet-navigation
                                            (openFacet)="setFacetOpen($event)"
                                            [mobileUI]="true"
                                            #productFacetNavigation></aimo-product-facet-navigation>
                                    </div>
                                    <div class="col-8 cx-sort-dropdown text-right">
                                        <ng-container *ngTemplateOutlet="aimoSorting"></ng-container>
                                    </div>
                                </div>
                            </div>
                            <!-- Desktop facets sticky -->
                            <div class="facet-list-wrapper d-none d-md-flex">
                                <div class="facet-list">
                                    <aimo-product-facet-navigation
                                        (openFacet)="setFacetOpen($event)"
                                        [mobileUI]="false"></aimo-product-facet-navigation>
                                </div>
                                <div class="facet-switch text-right">
                                    @if (favoriteToggleVisible() && loggedUser$ | async) {
                                        <div
                                            class="d-md-inline product-list-action product-list-action-md"
                                        >
                                            <label for="toggleFavorite">
                                                <div class="aimo-switch">
                                                    <input
                                                        id="toggleFavorite"
                                                        name="checkbox_toggleFavorite"
                                                        type="checkbox"
                                                        [value]="favoriteSelected"
                                                        [checked]="favoriteSelected"
                                                        (change)="toggleFavorite()"/>
                                                    <span class="slider round"></span>
                                                </div>
                                                <span>{{ 'productList.favorites' | cxTranslate }}</span>
                                            </label>
                                        </div>
                                    }
                                    @if (isSolrDebugInfoEnabled$ | async) {
                                        <div
                                            class="d-md-inline product-list-action product-list-action-md"
                                        >
                                            @if ({value: solrDebugInfoSelected$ | async}; as selected) {
                                                <label
                                                    for="toggleSolrDebugInfo"
                                                >
                                                    <div class="aimo-switch">
                                                        <input
                                                            id="toggleSolrDebugInfo"
                                                            name="checkbox_toggleSolrDebugInfo"
                                                            type="checkbox"
                                                            [value]="selected.value"
                                                            [checked]="selected.value"
                                                            (change)="setSolrDebugInfoSelected(!selected.value)"/>
                                                        <span class="slider round"></span>
                                                    </div>
                                                    <span>{{ 'productList.solrDebugInfo' | cxTranslate }}</span>
                                                </label>
                                            }
                                        </div>
                                    }
                                    @if (showClickAndCollect()) {
                                        <div
                                            class="d-md-inline product-list-action product-list-action-md"
                                        >
                                            <label class="aimo-switch" for="clickAndCollect">
                                                <input
                                                    id="clickAndCollect"
                                                    type="checkbox"
                                                    [checked]="clickAndCollectSelected"
                                                    (change)="toggleClickAndCollect()"/>
                                                <span class="slider round"></span>
                                            </label>
                                            <span>{{ 'productList.order.collect' | cxTranslate }}</span>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="cx-sorting-fixed-placeholder"></div>
                <!-- Mobile facets below sticky -->
                <div class="d-block d-md-none">
                    <div class="row">
                        <div class="col-12">
                            <aimo-active-facets [productSearchPage]="model"></aimo-active-facets>
                        </div>
                    </div>
                    <div class="row">
                        @if (favoriteToggleVisible() && loggedUser$ | async) {
                            <div class="col-6 mb-3">
                                <label for="toggleFavorite_mobile">
                                    <div class="aimo-switch">
                                        <input
                                            id="toggleFavorite_mobile"
                                            name="checkbox_toggleFavorite"
                                            type="checkbox"
                                            [value]="favoriteSelected"
                                            [checked]="favoriteSelected"
                                            (change)="toggleFavorite()"/>
                                        <span class="slider round"></span>
                                    </div>
                                    <span>{{ 'productList.favorites' | cxTranslate }}</span>
                                </label>
                            </div>
                        }
                        @if (showClickAndCollect()) {
                            <div class="col-6 mb-3">
                                <label class="aimo-switch" for="clickAndCollect_mobile">
                                    <input
                                        id="clickAndCollect_mobile"
                                        type="checkbox"
                                        [checked]="clickAndCollectSelected"
                                        (change)="toggleClickAndCollect()"/>
                                    <span class="slider round"></span>
                                </label>
                                <span>{{ 'productList.order.collect' | cxTranslate }}</span>
                            </div>
                        }
                    </div>
                    <div class="row">
                        <div class="col-4">
                            <ng-container *ngTemplateOutlet="aimoTotalResults"></ng-container>
                        </div>
                        <div class="col-8 text-right">
                            <ng-container *ngTemplateOutlet="aimoListActions"></ng-container>
                        </div>
                    </div>
                </div>
                <!-- Desktop facets below sticky -->
                <div class="active-facet-list-wrapper d-none d-md-flex">
                    <div class="active-facet-list">
                        <aimo-active-facets [productSearchPage]="model"></aimo-active-facets>
                        <ng-container *ngTemplateOutlet="aimoTotalResults"></ng-container>
                    </div>
                    <div class="cx-sort-dropdown text-right">
                        <ng-container *ngTemplateOutlet="aimoListActions"></ng-container>
                        <ng-container *ngTemplateOutlet="aimoSorting"></ng-container>
                    </div>
                </div>
            </div>
            <div id="product-results-list" class="cx-product-container">
                <aimo-product-scroll [setModel]="model"></aimo-product-scroll>
            </div>
            @if (model.pagination.totalResults < 1) {
                <cx-page-slot position="NoResultsSlot"></cx-page-slot>
            }
        }
    </section>
    <ng-template #aimoSorting>
        <aimo-sorting
            [sortOptions]="model.sorts"
            (sortListEvent)="sortList($event)"
            [selectedOption]="model.pagination?.sort"
            [ariaLabel]="'productList.sortResults' | cxTranslate"
            ariaControls="product-results-list"
            placeholder="{{ 'productList.sortBy' | cxTranslate }}"></aimo-sorting>
    </ng-template>
    <ng-template #aimoListActions>
        <div class="product-list-action d-inline-block">
            @if (loggedUser$ | async) {
                <a class="btn-link" (click)="excelExportProducts()">
                    <i class="aimo-icon icon-sm icon-inline icon-file-arrow-down"></i>
                    <span>{{ 'productList.export.excel' | cxTranslate }}</span>
                </a>
            }
        </div>
        <div class="product-list-action d-inline-block">
            <a class="btn-link" [id]="'print'" (click)="print()">
                <i class="aimo-icon icon-sm icon-inline icon-printer"></i>
                <span>{{ 'productList.print' | cxTranslate }}</span>
            </a>
        </div>
    </ng-template>
    <ng-template #aimoTotalResults>
              <span class="total-results">{{
                      'productList.noProducts' | cxTranslate: {count: model?.pagination.totalResults}
                  }}</span>
    </ng-template>
} @else {
    <aimo-spinner></aimo-spinner>
}

